/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs/Observable';

import { ResponseObj } from '../model/responseObj';
import { ResponseObjOfBookmarkP } from '../model/responseObjOfBookmarkP';
import { ResponseObjOfContentCustomerP } from '../model/responseObjOfContentCustomerP';
import { ResponseObjOfContentP } from '../model/responseObjOfContentP';
import { ResponseObjOfListOfBookmarkP } from '../model/responseObjOfListOfBookmarkP';
import { ResponseObjOfListOfContentP } from '../model/responseObjOfListOfContentP';
import { ResponseObjOfListOfHomescreenVodsP } from '../model/responseObjOfListOfHomescreenVodsP';
import { ResponseObjOfListOfLabelP } from '../model/responseObjOfListOfLabelP';
import { ResponseObjOfListOfMainBoardItemP } from '../model/responseObjOfListOfMainBoardItemP';
import { ResponseObjOfstring } from '../model/responseObjOfstring';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { query } from '@angular/core/src/render3/instructions';


@Injectable()
export class VodClientServicesService {

    protected basePath = 'https://www.sportstv.com.tr:8188/cms-vod-client';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * addFavContent
     * 
     * @param customerid customerid
     * @param contentid contentid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addFavContent(customerid: number, contentid: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfContentCustomerP>;
    public addFavContent(customerid: number, contentid: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfContentCustomerP>>;
    public addFavContent(customerid: number, contentid: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfContentCustomerP>>;
    public addFavContent(customerid: number, contentid: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (customerid === null || customerid === undefined) {
            throw new Error('Required parameter customerid was null or undefined when calling addFavContent.');
        }

        if (contentid === null || contentid === undefined) {
            throw new Error('Required parameter contentid was null or undefined when calling addFavContent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfContentCustomerP>(`${this.basePath}/addfavcontent/${encodeURIComponent(String(customerid))}/${encodeURIComponent(String(contentid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * dislikeContent
     * 
     * @param cid cid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dislikeContent(cid: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfstring>;
    public dislikeContent(cid: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfstring>>;
    public dislikeContent(cid: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfstring>>;
    public dislikeContent(cid: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (cid === null || cid === undefined) {
            throw new Error('Required parameter cid was null or undefined when calling dislikeContent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfstring>(`${this.basePath}/vods/${encodeURIComponent(String(cid))}/dislike`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getActiveCategories
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getActiveCategoriesUsingGET(observe?: 'body', reportProgress?: boolean): Observable<ResponseObj>;
    public getActiveCategoriesUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObj>>;
    public getActiveCategoriesUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObj>>;
    public getActiveCategoriesUsingGET(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        return this.httpClient.get<ResponseObj>(`${this.basePath}/categories`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAllMainBoardItems
     * 
     * @param categoryId categoryId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllMainBoardItemsWithParam(posterCode: number, categoryId?: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObj>;
    public getAllMainBoardItemsWithParam(posterCode: number, categoryId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObj>>;
    public getAllMainBoardItemsWithParam(posterCode: number, categoryId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObj>>;
    public getAllMainBoardItemsWithParam(posterCode: number, categoryId?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (categoryId !== undefined && categoryId !== null) {
            queryParameters = queryParameters.set('categoryId', <any>categoryId);
        }

        if (posterCode !== undefined && posterCode !== null) {
            queryParameters = queryParameters.set('codes', <any>posterCode);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.get<ResponseObjOfListOfMainBoardItemP>(`${this.basePath}/mainboarditems`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    public getAllMainBoardItems(posterCode: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObj>;
    public getAllMainBoardItems(posterCode: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObj>>;
    public getAllMainBoardItems(posterCode: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObj>>;
    public getAllMainBoardItems(posterCode: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.get<ResponseObjOfListOfMainBoardItemP>(`${this.basePath}/mainboarditems?codes=${posterCode}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    /**
     * getAllVods
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllVods(observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfContentP>;
    public getAllVods(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfContentP>>;
    public getAllVods(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfContentP>>;
    public getAllVods(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfListOfContentP>(`${this.basePath}/getallvods`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getBulkPublishedContentsOfContentG
     * 
     * @param groupIds groupIds
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBulkPublishedContentsOfContentG1(groupIds: Array<number>, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfContentP>;
    public getBulkPublishedContentsOfContentG1(groupIds: Array<number>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfContentP>>;
    public getBulkPublishedContentsOfContentG1(groupIds: Array<number>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfContentP>>;
    public getBulkPublishedContentsOfContentG1(groupIds: Array<number>, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (groupIds === null || groupIds === undefined) {
            throw new Error('Required parameter groupIds was null or undefined when calling getBulkPublishedContentsOfContentG1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResponseObjOfListOfContentP>(`${this.basePath}/getbulkpublishedcontentsofcontentgs`,
            groupIds,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getChilds
     * 
     * @param cntId cntId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getChilds(cntId: string, reverse: boolean, codes: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfContentP>;
    public getChilds(cntId: string, reverse: boolean, codes: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfContentP>>;
    public getChilds(cntId: string, reverse: boolean, codes: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfContentP>>;
    public getChilds(cntId: string, reverse: boolean, codes: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (cntId === null || cntId === undefined) {
            throw new Error('Required parameter cntId was null or undefined when calling getChilds1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (reverse !== undefined && reverse !== null) {
            queryParameters = queryParameters.set('reverse', <any>reverse);
        }

        if (codes !== undefined && codes !== null) {
            queryParameters = queryParameters.set('codes', <any>codes);
        }

        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfListOfContentP>(`${this.basePath}/vods/${encodeURIComponent(String(cntId))}/childs`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress

            }
        );
    }

    /**
     * getContentBookmark
     * 
     * @param custId custId
     * @param cntId cntId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getContentBookmark(custId: number, cntId: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfBookmarkP>;
    public getContentBookmark(custId: number, cntId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfBookmarkP>>;
    public getContentBookmark(custId: number, cntId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfBookmarkP>>;
    public getContentBookmark(custId: number, cntId: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (custId === null || custId === undefined) {
            throw new Error('Required parameter custId was null or undefined when calling getContentBookmark.');
        }

        if (cntId === null || cntId === undefined) {
            throw new Error('Required parameter cntId was null or undefined when calling getContentBookmark.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfBookmarkP>(`${this.basePath}/getbookmark/${encodeURIComponent(String(custId))}/${encodeURIComponent(String(cntId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getContentGroupIds
     * 
     * @param contentid contentid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getContentGroupIds(contentid: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfContentP>;
    public getContentGroupIds(contentid: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfContentP>>;
    public getContentGroupIds(contentid: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfContentP>>;
    public getContentGroupIds(contentid: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (contentid === null || contentid === undefined) {
            throw new Error('Required parameter contentid was null or undefined when calling getContentGroupIds.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfContentP>(`${this.basePath}/getcontentgroupids/${encodeURIComponent(String(contentid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getContentPlayUrl
     * 
     * @param cid cid
     * @param dpname dpname
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getContentPlayUrl(cid: number, dpname: string, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfstring>;
    public getContentPlayUrl(cid: number, dpname: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfstring>>;
    public getContentPlayUrl(cid: number, dpname: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfstring>>;
    public getContentPlayUrl(cid: number, dpname: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (cid === null || cid === undefined) {
            throw new Error('Required parameter cid was null or undefined when calling getContentPlayUrl.');
        }

        if (dpname === null || dpname === undefined) {
            throw new Error('Required parameter dpname was null or undefined when calling getContentPlayUrl.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfstring>(`${this.basePath}/contentplayurl/${encodeURIComponent(String(cid))}/${encodeURIComponent(String(dpname))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getContinueToWatchContents
     * 
     * @param customerid customerid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getContinueToWatchContents(customerid: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfContentP>;
    public getContinueToWatchContents(customerid: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfContentP>>;
    public getContinueToWatchContents(customerid: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfContentP>>;
    public getContinueToWatchContents(customerid: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (customerid === null || customerid === undefined) {
            throw new Error('Required parameter customerid was null or undefined when calling getContinueToWatchContents.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfListOfContentP>(`${this.basePath}/getcontinuetowatchcontents/${encodeURIComponent(String(customerid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getFavContents
     * 
     * @param customerid customerid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFavContents(customerid: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfContentP>;
    public getFavContents(customerid: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfContentP>>;
    public getFavContents(customerid: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfContentP>>;
    public getFavContents(customerid: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (customerid === null || customerid === undefined) {
            throw new Error('Required parameter customerid was null or undefined when calling getFavContents.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfListOfContentP>(`${this.basePath}/getfavcontents/${encodeURIComponent(String(customerid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getHomeScreenLabels
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getHomeScreenLabels(observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfLabelP>;
    public getHomeScreenLabels(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfLabelP>>;
    public getHomeScreenLabels(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfLabelP>>;
    public getHomeScreenLabels(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfListOfLabelP>(`${this.basePath}/gethomescreenlabels`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getHomescreenVods
     * 
     * @param cusid cusid
     * @param platform platform
     * @param categoryId categoryId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getHomescreenVods(cusid: number, posterCode: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfHomescreenVodsP>;
    public getHomescreenVods(cusid: number, posterCode: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfHomescreenVodsP>>;
    public getHomescreenVods(cusid: number, posterCode: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfHomescreenVodsP>>;
    public getHomescreenVods(cusid: number, posterCode: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (cusid === null || cusid === undefined) {
            throw new Error('Required parameter cusid was null or undefined when calling getHomescreenVods1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.get<ResponseObjOfListOfHomescreenVodsP>(`${this.basePath}/vods/gethomescreenvods/${encodeURIComponent(String(cusid))}?codes=${posterCode}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    public getHomescreenVodsWithQuery(cusid: number, posterCode: number, categoryId?: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfHomescreenVodsP>;
    public getHomescreenVodsWithQuery(cusid: number, posterCode: number, categoryId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfHomescreenVodsP>>;
    public getHomescreenVodsWithQuery(cusid: number, posterCode: number, categoryId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfHomescreenVodsP>>;
    public getHomescreenVodsWithQuery(cusid: number, posterCode: number, categoryId?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (cusid === null || cusid === undefined) {
            throw new Error('Required parameter cusid was null or undefined when calling getHomescreenVods1.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (categoryId !== undefined && categoryId !== null) {
            queryParameters = queryParameters.set('categoryId', <any>categoryId);
        }

        if (posterCode !== undefined && posterCode !== null) {
            queryParameters = queryParameters.set('codes', <any>posterCode);
        }
        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.get<ResponseObjOfListOfHomescreenVodsP>(`${this.basePath}/vods/homescreen`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    public getVodsForContentDetail(categoryId: number, posterCode: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfHomescreenVodsP>;
    public getVodsForContentDetail(categoryId: number, posterCode: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfHomescreenVodsP>>;
    public getVodsForContentDetail(categoryId: number, posterCode: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfHomescreenVodsP>>;
    public getVodsForContentDetail(categoryId: number, posterCode: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (posterCode !== undefined && posterCode !== null) {
            queryParameters = queryParameters.set('codes', <any>posterCode);
        }
        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.get<ResponseObjOfListOfHomescreenVodsP>(`${this.basePath}/categories/${encodeURIComponent(String(categoryId))}/vods/detail`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    /**
     * getHomescreenVodsFirstPage
     * 
     * @param platform platform
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getHomescreenVodsFirstPage1(platform: string, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfHomescreenVodsP>;
    public getHomescreenVodsFirstPage1(platform: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfHomescreenVodsP>>;
    public getHomescreenVodsFirstPage1(platform: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfHomescreenVodsP>>;
    public getHomescreenVodsFirstPage1(platform: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (platform === null || platform === undefined) {
            throw new Error('Required parameter platform was null or undefined when calling getHomescreenVodsFirstPage1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfListOfHomescreenVodsP>(`${this.basePath}/gethomescreenvodsfirstpage/${encodeURIComponent(String(platform))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getLabels
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLabels(observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfLabelP>;
    public getLabels(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfLabelP>>;
    public getLabels(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfLabelP>>;
    public getLabels(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfListOfLabelP>(`${this.basePath}/getLabels`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getLastAddedContents
     * 
     * @param platform platform
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLastAddedContents(platform: string, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfContentP>;
    public getLastAddedContents(platform: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfContentP>>;
    public getLastAddedContents(platform: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfContentP>>;
    public getLastAddedContents(platform: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (platform === null || platform === undefined) {
            throw new Error('Required parameter platform was null or undefined when calling getLastAddedContents1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfListOfContentP>(`${this.basePath}/getlastaddedcontents/${encodeURIComponent(String(platform))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getMenuLabels
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMenuLabels(categoryID: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfLabelP>;
    public getMenuLabels(categoryID: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfLabelP>>;
    public getMenuLabels(categoryID: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfLabelP>>;
    public getMenuLabels(categoryID: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfListOfLabelP>(`${this.basePath}/categories/${categoryID}/labels`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getMostViewedContents
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMostViewedContents(observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfContentP>;
    public getMostViewedContents(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfContentP>>;
    public getMostViewedContents(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfContentP>>;
    public getMostViewedContents(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfListOfContentP>(`${this.basePath}/getmostviewedcontents`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getPublishedContentsOfContentG
     * 
     * @param cgid cgid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPublishedContentsOfContentG1(cgid: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfContentP>;
    public getPublishedContentsOfContentG1(cgid: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfContentP>>;
    public getPublishedContentsOfContentG1(cgid: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfContentP>>;
    public getPublishedContentsOfContentG1(cgid: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (cgid === null || cgid === undefined) {
            throw new Error('Required parameter cgid was null or undefined when calling getPublishedContentsOfContentG1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfListOfContentP>(`${this.basePath}/getpublishedcontentsofcontentg/${encodeURIComponent(String(cgid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getRelatedContent
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRelatedContent(id: number, posterCode: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfContentP>;
    public getRelatedContent(id: number, posterCode: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfContentP>>;
    public getRelatedContent(id: number, posterCode: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfContentP>>;
    public getRelatedContent(id: number, posterCode: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getRelatedContent1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObj>(`${this.basePath}/vods/${encodeURIComponent(String(id))}/related?codes=${posterCode}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
   * getNextVod
   * 
   * @param id id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public getNextVod(id: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfContentP>;
    public getNextVod(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfContentP>>;
    public getNextVod(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfContentP>>;
    public getNextVod(id: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getnextvod.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfContentP>(`${this.basePath}/vods/${encodeURIComponent(String(id))}/next`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getVod
     * 
     * @param contentid contentid
     * @param dpname dpname
     * @param check check
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVod(contentid: number, dpname: string, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfContentP>;
    public getVod(contentid: number, dpname: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfContentP>>;
    public getVod(contentid: number, dpname: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfContentP>>;
    public getVod(contentid: number, dpname: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (contentid === null || contentid === undefined) {
            throw new Error('Required parameter contentid was null or undefined when calling getVod.');
        }



        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (dpname !== undefined && dpname !== null) {
            queryParameters = queryParameters.set('dpname', <any>dpname);
        }
        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfContentP>(`${this.basePath}/vods/${encodeURIComponent(String(contentid))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getVodByLabel
     * 
     * @param label label
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVodByLabel(label: string, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfContentP>;
    public getVodByLabel(label: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfContentP>>;
    public getVodByLabel(label: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfContentP>>;
    public getVodByLabel(label: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (label === null || label === undefined) {
            throw new Error('Required parameter label was null or undefined when calling getVodByLabel1.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (label !== undefined && label !== null) {
            queryParameters = queryParameters.set('label', <any>label);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfListOfContentP>(`${this.basePath}/labels/${label}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getVodById
     * 
     * @param labelid labelid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVodByLabelId(labelid: number, codes: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfContentP>;
    public getVodByLabelId(labelid: number, codes: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfContentP>>;
    public getVodByLabelId(labelid: number, codes: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfContentP>>;
    public getVodByLabelId(labelid: number, codes: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (labelid === null || labelid === undefined) {
            throw new Error('Required parameter labelid was null or undefined when calling getVodByLabelId1.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (codes !== undefined && codes !== null) {
            queryParameters = queryParameters.set('codes', <any>codes);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfListOfContentP>(`${this.basePath}/labels/${labelid}/vods`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getCustomerBookmark
     * 
     * @param custId custId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getcustomerbookmark(custId: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfBookmarkP>;
    public getcustomerbookmark(custId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfBookmarkP>>;
    public getcustomerbookmark(custId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfBookmarkP>>;
    public getcustomerbookmark(custId: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (custId === null || custId === undefined) {
            throw new Error('Required parameter custId was null or undefined when calling getcustomerbookmark.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfListOfBookmarkP>(`${this.basePath}/getcustomerbookmark/${encodeURIComponent(String(custId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getHomeScreenVodsNextPage
     * 
     * @param platform platform
     * @param labelid labelid
     * @param pagenumber pagenumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public gethomescreenvodsnextpage(platform: string, labelid: number, pagenumber: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfListOfHomescreenVodsP>;
    public gethomescreenvodsnextpage(platform: string, labelid: number, pagenumber: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfListOfHomescreenVodsP>>;
    public gethomescreenvodsnextpage(platform: string, labelid: number, pagenumber: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfListOfHomescreenVodsP>>;
    public gethomescreenvodsnextpage(platform: string, labelid: number, pagenumber: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (platform === null || platform === undefined) {
            throw new Error('Required parameter platform was null or undefined when calling gethomescreenvodsnextpage1.');
        }

        if (labelid === null || labelid === undefined) {
            throw new Error('Required parameter labelid was null or undefined when calling gethomescreenvodsnextpage1.');
        }

        if (pagenumber === null || pagenumber === undefined) {
            throw new Error('Required parameter pagenumber was null or undefined when calling gethomescreenvodsnextpage1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfListOfHomescreenVodsP>(`${this.basePath}/gethomescreenvodsnextpage/${encodeURIComponent(String(platform))}/${encodeURIComponent(String(labelid))}/${encodeURIComponent(String(pagenumber))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * likeContent
     * 
     * @param cid cid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public likeContent(cid: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfstring>;
    public likeContent(cid: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfstring>>;
    public likeContent(cid: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfstring>>;
    public likeContent(cid: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (cid === null || cid === undefined) {
            throw new Error('Required parameter cid was null or undefined when calling likeContent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfstring>(`${this.basePath}/vods/${encodeURIComponent(String(cid))}/like`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * removeFavContent
     * 
     * @param customerid customerid
     * @param contentid contentid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeFavContent(customerid: number, contentid: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObjOfContentCustomerP>;
    public removeFavContent(customerid: number, contentid: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObjOfContentCustomerP>>;
    public removeFavContent(customerid: number, contentid: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObjOfContentCustomerP>>;
    public removeFavContent(customerid: number, contentid: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (customerid === null || customerid === undefined) {
            throw new Error('Required parameter customerid was null or undefined when calling removeFavContent.');
        }

        if (contentid === null || contentid === undefined) {
            throw new Error('Required parameter contentid was null or undefined when calling removeFavContent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObjOfContentCustomerP>(`${this.basePath}/removefavcontent/${encodeURIComponent(String(customerid))}/${encodeURIComponent(String(contentid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * search
     * 
     * @param text text
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchUsingGET(text: string, codes: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObj>;
    public searchUsingGET(text: string, codes: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObj>>;
    public searchUsingGET(text: string, codes: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObj>>;
    public searchUsingGET(text: string, codes: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (text === null || text === undefined) {
            throw new Error('Required parameter text was null or undefined when calling searchUsingGET.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (text !== undefined && text !== null) {
            queryParameters = queryParameters.set('text', <any>text);
        }

        if (codes !== undefined && codes !== null) {
            queryParameters = queryParameters.set('codes', <any>codes);
        }
        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObj>(`${this.basePath}/vods/search`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * setContentBookmark
     * 
     * @param custId custId
     * @param cntId cntId
     * @param time time
     * @param duration duration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setContentBookmark(custId: number, cntId: number, time: number, duration: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObj>;
    public setContentBookmark(custId: number, cntId: number, time: number, duration: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObj>>;
    public setContentBookmark(custId: number, cntId: number, time: number, duration: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObj>>;
    public setContentBookmark(custId: number, cntId: number, time: number, duration: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (custId === null || custId === undefined) {
            throw new Error('Required parameter custId was null or undefined when calling setContentBookmark.');
        }

        if (cntId === null || cntId === undefined) {
            throw new Error('Required parameter cntId was null or undefined when calling setContentBookmark.');
        }

        if (time === null || time === undefined) {
            throw new Error('Required parameter time was null or undefined when calling setContentBookmark.');
        }

        if (duration === null || duration === undefined) {
            throw new Error('Required parameter duration was null or undefined when calling setContentBookmark.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<ResponseObj>(`${this.basePath}/setbookmark/${encodeURIComponent(String(custId))}/${encodeURIComponent(String(cntId))}/${encodeURIComponent(String(time))}/${encodeURIComponent(String(duration))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * startVod
     * 
     * @param contentid contentid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public startVodUsingGET(contentid: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObj>;
    public startVodUsingGET(contentid: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObj>>;
    public startVodUsingGET(contentid: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObj>>;
    public startVodUsingGET(contentid: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (contentid === null || contentid === undefined) {
            throw new Error('Required parameter contentid was null or undefined when calling startVodUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObj>(`${this.basePath}/vods/${encodeURIComponent(String(contentid))}/start`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * stopVod
     * 
     * @param contentid contentid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stopVodUsingGET(contentid: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseObj>;
    public stopVodUsingGET(contentid: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseObj>>;
    public stopVodUsingGET(contentid: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseObj>>;
    public stopVodUsingGET(contentid: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (contentid === null || contentid === undefined) {
            throw new Error('Required parameter contentid was null or undefined when calling stopVodUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseObj>(`${this.basePath}/vods/${encodeURIComponent(String(contentid))}/stop`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/cms-vod-client-api/api/vodClientServices.service.ts